
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 118.2 118.2"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{staticClass:"st0",attrs:{"fill":"#6D83D5","cx":"58.9","cy":"58.9","r":"58.4"}}),_c('circle',{attrs:{"fill":"#fff","cx":"60.1","cy":"59","r":"42.8"}}),_c('path',{staticClass:"st0",attrs:{"fill":"#6D83D5","d":"M69.3 67c-.2 2.6-2.4 4.6-5 4.6H53.9c-2.6 0-4.8-2-5-4.6L46 28.6c-.2-2.8 1.9-5.2 4.6-5.4h16.5c2.8 0 5 2.2 5 5v.4L69.3 67zm-.2 23c0 2.8-2.2 5-5 5h-10c-2.8 0-5-2.2-5-5v-8.4c0-2.8 2.2-5 5-5h10c2.8 0 5 2.2 5 5V90zm-10-80.9c-27.6 0-50 22.4-50 50s22.4 50 50 50 50-22.4 50-50c0-13.3-5.3-26-14.6-35.4-9.4-9.4-22.2-14.6-35.4-14.6z"}})])
          )
        }
      }
    